import Documents from "@/components/widgets/documents";
import DepositDocuments from "@/components/widgets/depositdocuments";
import Seller from "@/components/widgets/seller";
import DatePicker from "vue2-datepicker";
import Loading from "@/components/widgets/Loading.vue";

export default {
  name: "Bill-Document",
  components: {
    Documents,
    Seller,
    DatePicker,
    DepositDocuments,
    Loading
  },
  props: {
    documentItem: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      role: "",
      selectedSeller: {},
      selectedCustomer: {},
      documentEnabled: false,
      depositDocumentEnabled: false,
      isSellerEnabled: false,
      bank_account_list: [],
      formData: {
        bill_payment_method: null,
        bill_duedate: null,
        bill_shipping_method: null,
        bill_shipping_date: null,
        bill_quotation_no: "",
        bill_delivery_date: new Date(),
        bill_manipulator: "",
        bill_seller: "",
        bill_seller_id: "",
        bill_reference: "",
        bill_deposit_type: 0,
        bill_deposit_amt: "",
        deposit_document_id: null,
        deposit_document_no: "",
        bill_credit_detail: null,
        bank_account_detail: null,
      },
    };
  },
  mounted() {
    this.getRoleOfUser();
  },
  computed: {
    // ผู้ขายเปลี่ยนได้เฉพาะ Admin / Branch Admin / Branch Admin assistant / Customer assistant manager
    // (allowlist เดียวกับหน้าใบเสนอราคา) role อื่นล็อกเป็นชื่อตัวเอง/ค่าเดิมของเอกสาร
    canEditSeller() {
      return ['Admin', 'Branch Admin', 'Branch Admin assistant', 'Customer assistant manager'].includes(this.role);
    },
  },
  watch: {
    "formData.bill_payment_method"(new_val) {
      this.onLoadBankAccount();
    },
    documentItem: {
      handler(newValue, oldValue) {
        this.formData = newValue;
      },
      deep: true,
    },
    formData: {
      handler(newValue, oldValue) {
        this.$emit("documentData", {
          document: newValue,
        });
      },
      deep: true,
    },
  },
  methods: {
    async onLoadBankAccount() {
      try {
        this.loading = true;
        const res = await this.$axios.get(
          this.$host +
          "/api/v1/document/quotation/branch/bank_accounts/type/" +
          this.formData.bill_payment_method
        );

        this.bank_account_list = res.data;
        this.loading = false;

      } catch (error) {
        this.loading = false;

        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async getRoleOfUser() {
      const res = await this.$store.dispatch(
        "Auth/getRole",
        {},
        { root: true }
      );
      if (res.status === 200) {
        this.role = res.data.role;
        if (!this.formData.bill_manipulator) {
          this.formData.bill_manipulator = res.data.name;
        }
        // prefill ผู้ขายเป็นตัวเองเฉพาะสร้างบิลใหม่เปล่า ๆ เท่านั้น —
        // ถ้ามี :id (prefill จากบิล/delivery หรือแก้ไข) ต้องคงผู้ขายจากเอกสารเดิม
        if (!this.$route.query.q && !this.$route.params.id) {
          this.formData.bill_seller = res.data.name;
          this.formData.bill_seller_id = res.data.id;
        }
        else{
          const res = await this.$axios.get(
            this.$host + "/api/v1/document/quotation/" + this.$route.query.q,
            {
              headers: {},
            }
          );
          this.formData.bill_payment_method = res.data.payment_type
          this.formData.bank_account_detail = res.data.bank_account_detail
          this.formData.bill_credit_detail = res.data.credit_detail
        }
      }
    },
    onOpenSellerPopup() {
      this.isSellerEnabled = !this.isSellerEnabled;
    },
    /** เปิด dialog ค้นหาข้อมูลใบส่งสินค้า */
    onOpenDocumentHandler() {
      this.documentEnabled = !this.documentEnabled;
    },
    onOpenDepositHandler() {
      this.depositDocumentEnabled = !this.depositDocumentEnabled;
    },
    /** เพิ่มข้อมูลใบมัดจำ — แนบ 2 ฐาน (excl/incl) + tax ของใบมัดจำ ให้ summary คิด VAT ตามฐานบิล */
    onInitDepositDocumentSettings(e) {
      this.depositDocumentEnabled = false;
      if (e.status) {
        const data = e.data;
        // มัดจำ 2 ฐาน: exclVat (before_vat, ถอด VAT) / inclVat (grand_total, สุทธิรวม VAT)
        // เอกสารเก่า/ไม่มี VAT → fallback ยอดดิบ (amount)
        const depAmount = Number(data.amount != null ? data.amount : 0);
        const depExcl = Number(data.before_vat != null ? data.before_vat : depAmount);
        const depIncl = Number(data.grand_total != null ? data.grand_total : depAmount);
        const depTaxType = Number(data.tax_type != null ? data.tax_type : 0);
        // เตือนถ้า type VAT ใบมัดจำ ≠ type บิล (รับได้ — คิดตามฐานบิลเสมอ ตามเกณฑ์ A — แต่ให้ผู้ใช้รู้ตัว)
        const billTaxType = Number(this.documentItem && this.documentItem.bill_tax_type != null ? this.documentItem.bill_tax_type : 0);
        if (depTaxType !== billTaxType) {
          const label = (t) => (t === 1 ? "บิลแยก VAT" : t === 2 ? "บิลรวม VAT" : "บิลไม่มี VAT");
          this.$swal({
            icon: "warning",
            title: "ประเภท VAT ไม่ตรงกัน",
            html: `ใบมัดจำเป็น <b>${label(depTaxType)}</b> แต่บิลเป็น <b>${label(billTaxType)}</b><br>ระบบจะคิดหักมัดจำตามฐาน VAT ของบิล — โปรดตรวจสอบให้ถูกต้อง`,
            confirmButtonText: "รับทราบ",
          });
        }
        // bill_deposit_amt ตั้งต้น = สุทธิ (incl); summary จะ recompute ฐานตาม bill_tax_type ที่ถูกต้องอีกที
        this.formData.bill_deposit_amt = depIncl;
        this.formData.deposit_excl_vat = depExcl;
        this.formData.deposit_incl_vat = depIncl;
        this.formData.deposit_tax_type = depTaxType;
        this.formData.deposit_document_id = data.id;
        this.formData.deposit_document_no = data.document_no;
      }
    },
    onRemoveDeposit(){
      this.formData.bill_deposit_amt = 0;
      this.formData.deposit_excl_vat = 0;
      this.formData.deposit_incl_vat = 0;
      this.formData.deposit_tax_type = 0;
      this.formData.deposit_document_id = null;
      this.formData.deposit_document_no = null;
    },
    onRemoveDocument(){
      this.formData.bill_quotation_no = '';
      this.formData.bill_quotation_id = null;
    },
    /** เพิ่มข้อมูลใบมัดจำ */
    onInitDocumentSettings(e) {
      this.documentEnabled = false;
      if (e.status) {
        const data = e.data;
        this.formData.bill_quotation_no = data.quotation_no;
        this.formData.bill_quotation_id = data.id;
      }
    },
    onSetSeller(e) {
      this.isSellerEnabled = false;
      const seller_name = e.data.name;
      this.formData.bill_seller = seller_name;
      this.formData.bill_seller_id = e.data.id;
    },
    onclear() {
      this.formData.bill_payment_method = null;
      this.formData.bill_duedate = null;
      this.formData.bill_shipping_method = null;
      this.formData.bill_shipping_date = null;
      this.formData.bill_quotation_no = "";
      this.formData.bill_delivery_date = null;
      this.formData.bill_manipulator = "";
      this.formData.bill_seller = "";
      this.formData.bill_id = "";
      this.formData.bill_reference = "";
      this.formData.deposit_document_id = null,
      this.formData.deposit_document_no = "",
      this.formData.bill_credit_detail = null
      this.formData.bank_account_detail = null
    },
  },
};
